import TabContentItemProvider from './hooks/useTabContentItem';

import { TabContentItemProps } from './@types/TabContentItemProps';
import TabContentItemContainer from './handles/TabContentItemContainer';

const TabContentItem = (props: TabContentItemProps) => (
	<TabContentItemProvider {...props}>
		<TabContentItemContainer>{props.children}</TabContentItemContainer>
	</TabContentItemProvider>
);

export default TabContentItem;
